import { getCookie, getParam, getUA, setCookie } from 'core/singleton'
import { v4 as UUID } from 'uuid'

function _getBrowser() {
  const ua = navigator.userAgent.toLowerCase()
  if (/chrome/.test(ua)) return 'Chrome'
  if (/opera/.test(ua)) return 'Opera'
  if (/staroffice/.test(ua)) return 'Star Office'
  if (/webtv/.test(ua)) return 'WebTV'
  if (/beonex/.test(ua)) return 'Beonex'
  if (/chimera/.test(ua)) return 'Chimera'
  if (/netpositive/.test(ua)) return 'NetPositive'
  if (/phoenix/.test(ua)) return 'Phoenix'
  if (/firefox/.test(ua)) return 'Firefox'
  if (/safari/.test(ua)) return 'Safari'
  if (/skipstone/.test(ua)) return 'SkipStone'
  if (/msie/.test(ua)) return 'Internet Explorer'
  if (/netscape/.test(ua)) return 'Netscape'
  if (/mozilla\/5\.0/.test(ua)) return 'Mozilla'
  if (/whale/.test(ua)) return 'Whale'
  if (/edge/.test(ua)) return 'Edge'
  return 'Etc'
}
function _getSessionId() {
  let suid = getCookie('suid')
  if (!suid) {
    const expires = new Date()
    expires.setFullYear(expires.getFullYear() + 10)
    suid = UUID().replace(/-/gi, '')
    setCookie('suid', suid, expires)
  }
  return suid
}
function _getFC() {
  const roomId = window.location.pathname.replace(/\/broadcast\/|\/admin\//, '')
  let fc = getParam('fc')
  const expires = new Date()
  expires.setHours(expires.getHours() + 1)
  if (fc) {
    setCookie(roomId, fc, expires)
  } else {
    fc = getCookie('fc')
  }
  return fc
}
function _getReferrer() {
  let referrer = getParam('sref')
  if (!referrer) {
    if (document.referrer) {
      if (/player.sauceflex.com/.test(document.referrer)) {
        referrer = 'direct'
      } else if (/android-app:\/\//.test(document.referrer)) {
        const match = document.referrer.match(/^(?:android-app:\/\/)?([^:/\n?=]+)/im)
        referrer = (match && match.length > 1 ? match[1] : undefined) || document.referrer
      } else {
        const match = document.referrer.match(
          /^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:/\n?=]+)/im,
        )
        referrer = (match && match.length > 1 ? match[1] : undefined) || document.referrer
      }
    } else {
      referrer = 'direct'
    }
  }
  return referrer
}
function _initKinesis() {
  const userQueryString = window.location.search.replace(/^\?/, '') || undefined
  const npc = getParam('npc')
  const recommendSessionToken = getParam('recommendSessionToken')
  const recommendProductCategory = getParam('recommendProductCategory')
  const isTestingGroup = getParam('isTestingGroup') === 'true'
  const fc = _getFC()
  const referrer = _getReferrer()
  const { os } = getUA()
  const _os = os && ['Android', 'iOS', 'Mac OS', 'Windows'].includes(os) ? os : 'Etc'
  const sessionId = _getSessionId()
  const userBrowser = _getBrowser()
  const userAgent = navigator.userAgent
  const userHost = window.location.origin
  const userUri = window.location.pathname
  const playStart = new Date().toISOString()

  return {
    userQueryString,
    npc,
    recommendSessionToken,
    recommendProductCategory,
    isTestingGroup,
    isViewRc: npc === 'rcm',
    fc,
    referrer,
    os: _os,
    isNew: 'false',
    sessionId,
    userBrowser,
    userAgent,
    userHost,
    userUri,
    playStart,
  }
}

function getKinesis() {
  return _kineis
}

const _kineis = _initKinesis()

export { getKinesis }
